<style lang="less" scoped>
.hotNews {text-align: left;margin: auto;}
ul {position: relative;list-style: none;margin-top: 0px;padding: 0px;}
li {border-top: 1px solid #cccccc;padding: 10px 0;height: 80px;cursor: pointer;display: flex;}
.picbox{width: 100px; height: 80px;overflow: hidden;}
.pic{margin-top: -3px;}
.box{position: absolute;left: 110px;width: 200px;}
.titleIcon {line-height: 25px;white-space: nowrap;}
.title {float: left;margin: -6px 8px 0px 0px;font-size: 15px;font-weight: 600;max-width: 230px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.icon {position: absolute;top:-2px;}
.text {font-size: 13px; width: 270px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;color: #666666;margin: 8px 0;}
.text{height: 28px;line-height: 14px; overflow:hidden;}
.text::after{content: ' ... ';}
.time{font-size: 13px;color: #000000;}
.box:hover {color: #13569e;}
.font1{font-size: 18px;font-weight: bold;}
.more{float: right;cursor: pointer;
  span{font-size: 16px;font-weight: 600;color: rgb(49, 49, 49);}
  span:hover{color: #13569e;}
  img{vertical-align: bottom;}
}
</style>

<!--何宽
    该组件使用场景：（矿业论坛首页）左边为新闻的图片，右边为新闻的标题和内容
    鼠标点击 更多 或者 新闻标题或内容，返回相应的对象给父组件-->
<template>
  <div class="hotNews">
    <ul class="content" :style="{height:heightCSH+'px'}">
      <li v-for="(item, index) in hotNewslist" :key="index"  @click="clickHotNews(item)">
        <div class="picbox">
          <img class="pic" :src="item.pic" style="height: 100%;" />
        </div>
        <div class="box">
          <div class="titleIcon">
            <span class="title">{{ item.title }} </span>
            <img class="icon" v-if="index === 0" src="static/index/toutiao.png" />
            <img class="icon" v-if="index > 0" src="static/index/zuixin.png" />
          </div>
          <p class="text"> {{ item.text }} </p>
          <span class="time">{{item.time * 1000 | formatDate()}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['hotNewslist', 'heightCSH'],
  mixins: [filters],
  data()
  {
    return {
    }
  },
  updated()
  {
    var oList = document.querySelectorAll('.text')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(item =>
    {
      var oHeight = item.height
      if ((oHeight / 13) > 2)
        item.className = 'text'
    })
  },
  methods: {
    // 点击 新闻的 标题或者内容，将 整个news对象传递给父组件
    clickHotNews(item)
    {
      this.$emit('clickHotNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/HotNews.vue